import { BACKWARDS_BOGO_SUBEXPERIENCES } from './constants';

export const noop = () => { };

export const sanitizeImageUrl = (url = '') => url.replace(/<SIZE>/g, '400');

export const pipe = (...funcs) => (arg) => funcs.reduce((acc, cur) => cur(acc), arg);

export const sortItemToTopOfList = (list, itemToMove) => (
  (list || [])
    .slice()
    .sort((first, second) => {
      if (first === itemToMove) return -1;
      if (second === itemToMove) return 1;
      return 0;
    })
    // We will no longer need to slice at 16 once we have moved to searchModel
    .slice(0, 16) // no more than 16 items including the anchor
);

export const getProductImage = (productData) => productData.media?.image?.url || '';

export const getIsFeatureEnabled = ({ prop, config, defaultValue = false }) => {
  if (prop === false || config === false) return false;
  if (prop === true || config === true) return true;
  return defaultValue;
};

export const isPromotionEnabled = ({
  bogoEnabled, backwardsBogoEnabled, msbEnabled, bmsmEnabled, anchorItem
}) => {
  const experienceTag = anchorItem.pricing.promotion.experienceTag;
  const subExperienceTag = anchorItem.pricing.promotion.subExperienceTag;
  const matchesSubExperienceTag = (subExperience) => subExperience === subExperienceTag;
  const isBackwardsBogo = BACKWARDS_BOGO_SUBEXPERIENCES.some(matchesSubExperienceTag);
  const isBogo = experienceTag === 'BOGO';
  const isMSB = experienceTag === 'MSBONLINE';
  const isBmsm = experienceTag === 'BMSM';
  return (bogoEnabled && isBogo && (!isBackwardsBogo || backwardsBogoEnabled))
    || (msbEnabled && isMSB)
    || (bmsmEnabled && isBmsm);
};
